const contributors = {
  title: "Website Contributors",
  mdcontent: `
    
Website built by Zac Jones & David Rogers with help from:
\n
- **Photography & Graphics**
    - Angela Reid / Reidy's Photos (reidysphotos.smugmug.com) - Site Photography 
    - Beth Harrison - Planet Ice Altrincham
    - Jak Foster - Hull Ice Arena
    - Torr Baldwin - Oxford Ice Rink
    - Alex Grob - Planet Ice Solihull
    - Matthew Simpson - Coventry Skydome
    - Typhoons Committee - Fife Ice Arena
    - Selina Senguder
- **Testing & Feedback**
    - Ashley Johnson, Nathan Dove, Beth Harrison, Matt McConville, Alex Grob, Joe Shirlaw, Chris Beesley, Reef Woffenden, Ed Dunmore, Dylan Steed, Ben Chappell
- **Ideas**
    - Henry Burrell, Jaden Davies, Alex Grob - Achievements
    - Respondents of the 2023 and 2024 annual surveys
    - BUIHA Winter Camp 2025 participants
\n


Please contact the BUIHA Tech Team using the contact form for any questions or concerns regarding content or attributions.
`,
};
export default contributors;
